// extracted by mini-css-extract-plugin
export default {"box":"RoleLabel_box__ICOny","default":"RoleLabel_default__k5E-Q","authorizer":"RoleLabel_authorizer__mjxXp","salesRep":"RoleLabel_salesRep__IVhKx","admin":"RoleLabel_admin__0RsES"};